import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { TrustBar } from '../components/TrustBar';
import { StickyCTA } from '../components/StickyCTA';
/* Lazy-load below-fold sections to reduce initial JS and accelerate FCP/LCP. */
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-342">
      {/* Above-fold: eager for fastest LCP */}
      <HeroSection data-id="element-343" />
      <TrustBar data-id="element-344" />

      {/* Near-fold */}
      <Suspense fallback={null} data-id="element-345">
        <div className="cv-auto" data-id="element-346">
          <ContrastSection data-id="element-347" />
          <ForWhomSection data-id="element-348" />
          <BenefitsSection data-id="element-349" />
          <ContentPreview data-id="element-350" />
          <BonusSection data-id="element-351" />
          <PricingSection data-id="element-352" />
        </div>
      </Suspense>

      {/* Far below fold */}
      <Suspense fallback={null} data-id="element-353">
        <div className="cv-auto" data-id="element-354">
          <GuaranteeSection data-id="element-355" />
          <TestimonialsSection data-id="element-356" />
          <ExpertSection data-id="element-357" />
          <FAQSection data-id="element-358" />
          <Footer data-id="element-359" />
        </div>
        <SocialProofPopup data-id="element-360" />
      </Suspense>

      <StickyCTA data-id="element-361" />
    </main>;
}